import type { Category, JournalEntry } from "../../entities/ledger/types";
import { apiRequest } from "../../shared/api/client";

export function createCategory(bookID: string, name: string): Promise<{ category: Category; created: boolean }> {
  return apiRequest(`/v1/books/${encodeURIComponent(bookID)}/categories`, { method: "POST", body: { name } });
}

// Relabels a transaction; balances and money flow are untouched by design.
export function setTransactionCategory(bookID: string, transactionID: string, categoryID: string): Promise<JournalEntry> {
  return apiRequest(`/v1/transactions/${encodeURIComponent(transactionID)}/category`, {
    method: "PUT",
    body: { categoryId: categoryID },
  });
}
